import { Box, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  onBackToTaskList: () => void;
}

const BackButton = (props: IProps) => {
  const { onBackToTaskList } = props;

  const handleBackToTaskClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onBackToTaskList();
  };

  return (
    <Box ml={-3.5} mb={4}>
      <Button
        onClick={handleBackToTaskClick}
        // onKeyPress={handleBackToTaskKeyPress}
        id="back-to-task-list"
        data-selector="back-to-task-list"
        size="md"
        variant="ghost"
        leftIcon={<FontAwesomeIcon icon={faArrowLeft} className="utility-icon" />}
      >
        Back to task list
      </Button>
    </Box>
  );
};

export default BackButton;
